const COUNTRY_BASE = [
    { code: 'ES', name: 'Spain' },
    { code: 'US', name: 'United States' },
    { code: 'CA', name: 'Canada' },
    { code: 'MX', name: 'Mexico' },
    { code: 'FR', name: 'France' },
    { code: 'DE', name: 'Germany' },
    { code: 'IT', name: 'Italy' },
    { code: 'PT', name: 'Portugal' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'BE', name: 'Belgium' },
    { code: 'IE', name: 'Ireland' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'AT', name: 'Austria' },
    { code: 'AU', name: 'Australia' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'SG', name: 'Singapore' },
    { code: 'AE', name: 'United Arab Emirates' },
];
const REGION_DATA = {
    spain: [
        { code: 'ES-MD', name: 'Madrid' },
        { code: 'ES-CT', name: 'Catalonia' },
        { code: 'ES-VC', name: 'Valencian Community' },
        { code: 'ES-AN', name: 'Andalusia' },
        { code: 'ES-GA', name: 'Galicia' },
        { code: 'ES-PV', name: 'Basque Country' },
    ],
    'united states': [
        { code: 'US-CA', name: 'California' },
        { code: 'US-NY', name: 'New York' },
        { code: 'US-TX', name: 'Texas' },
        { code: 'US-FL', name: 'Florida' },
        { code: 'US-IL', name: 'Illinois' },
        { code: 'US-WA', name: 'Washington' },
    ],
    canada: [
        { code: 'CA-ON', name: 'Ontario' },
        { code: 'CA-QC', name: 'Quebec' },
        { code: 'CA-BC', name: 'British Columbia' },
        { code: 'CA-AB', name: 'Alberta' },
        { code: 'CA-MB', name: 'Manitoba' },
        { code: 'CA-NS', name: 'Nova Scotia' },
    ],
    mexico: [
        { code: 'MX-CMX', name: 'Ciudad de Mexico' },
        { code: 'MX-JAL', name: 'Jalisco' },
        { code: 'MX-NLE', name: 'Nuevo Leon' },
        { code: 'MX-BCN', name: 'Baja California' },
        { code: 'MX-MEX', name: 'Estado de Mexico' },
    ],
    france: [
        { code: 'FR-IDF', name: 'Ile-de-France' },
        { code: 'FR-ARA', name: 'Auvergne-Rhone-Alpes' },
        { code: 'FR-PAC', name: 'Provence-Alpes-Cote d\'Azur' },
        { code: 'FR-OCC', name: 'Occitanie' },
    ],
    germany: [
        { code: 'DE-BE', name: 'Berlin' },
        { code: 'DE-BY', name: 'Bavaria' },
        { code: 'DE-NW', name: 'North Rhine-Westphalia' },
        { code: 'DE-BW', name: 'Baden-Wurttemberg' },
    ],
    italy: [
        { code: 'IT-LAZ', name: 'Lazio' },
        { code: 'IT-CAM', name: 'Campania' },
        { code: 'IT-LOM', name: 'Lombardy' },
        { code: 'IT-TOS', name: 'Tuscany' },
    ],
};
const CITY_DATA = {
    'spain|madrid': [
        { code: 'ES-MAD', name: 'Madrid' },
        { code: 'ES-ALC', name: 'Alcobendas' },
        { code: 'ES-LEG', name: 'Leganes' },
    ],
    'spain|catalonia': [
        { code: 'ES-BCN', name: 'Barcelona' },
        { code: 'ES-GIR', name: 'Girona' },
        { code: 'ES-TAR', name: 'Tarragona' },
    ],
    'spain|valencian community': [
        { code: 'ES-VLC', name: 'Valencia' },
        { code: 'ES-ALC2', name: 'Alicante' },
        { code: 'ES-ELC', name: 'Elche' },
    ],
    'spain|andalusia': [
        { code: 'ES-SEV', name: 'Seville' },
        { code: 'ES-MAL', name: 'Malaga' },
        { code: 'ES-GRA', name: 'Granada' },
    ],
    'united states|california': [
        { code: 'US-SF', name: 'San Francisco' },
        { code: 'US-LA', name: 'Los Angeles' },
        { code: 'US-SD', name: 'San Diego' },
        { code: 'US-SJ', name: 'San Jose' },
    ],
    'united states|new york': [
        { code: 'US-NYC', name: 'New York City' },
        { code: 'US-BUF', name: 'Buffalo' },
        { code: 'US-ROC', name: 'Rochester' },
    ],
    'united states|texas': [
        { code: 'US-AUS', name: 'Austin' },
        { code: 'US-DAL', name: 'Dallas' },
        { code: 'US-HOU', name: 'Houston' },
    ],
    'canada|ontario': [
        { code: 'CA-TOR', name: 'Toronto' },
        { code: 'CA-OTT', name: 'Ottawa' },
        { code: 'CA-WSR', name: 'Windsor' },
    ],
    'canada|british columbia': [
        { code: 'CA-VAN', name: 'Vancouver' },
        { code: 'CA-VIC', name: 'Victoria' },
        { code: 'CA-KEL', name: 'Kelowna' },
    ],
    'france|ile-de-france': [
        { code: 'FR-PAR', name: 'Paris' },
        { code: 'FR-VER', name: 'Versailles' },
    ],
    'germany|berlin': [
        { code: 'DE-BER', name: 'Berlin' },
    ],
    'italy|lazio': [
        { code: 'IT-ROM', name: 'Rome' },
    ],
};
const normalize = (value) => value.trim().toLowerCase();
export function getCountryOptions() {
    return COUNTRY_BASE;
}
export function getRegionsForCountry(country) {
    return REGION_DATA[normalize(country)] || [];
}
export function getCitiesForCountryAndRegion(country, region) {
    const key = `${normalize(country)}|${normalize(region)}`;
    return CITY_DATA[key] || [];
}
